export default "__VITE_ASSET__CKhsL8be__"